import { useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import { SERVICE_TYPES } from "../utils/constants/fieldErrors";

const useServiceType = () => {
  // 1 is Private individual form
  // 2 is creditinfo form
  const pathname = useHistory().location.pathname;
  const splitPath = pathname.split("/");
  const [serviceType, setServiceType] = useState("");
  const [serviceTypeForCallBack, setServiceTypeForCallBack] = useState("");
  const serviceTypeFromCallback = useRef({ current: null });

  useEffect(() => {
    switch (splitPath[1].toLocaleLowerCase()) {
      case "contactinfochange":
        setServiceType(SERVICE_TYPES.ContactInfoChangeForm);
        setServiceTypeForCallBack(SERVICE_TYPES.ContactInfoChangeForm);
        break;
      case "creditinfo":
        setServiceType(SERVICE_TYPES.creditInfoForm);
        setServiceTypeForCallBack(SERVICE_TYPES.creditInfoForm);
        break;
      case "ibregistration":
        setServiceType(SERVICE_TYPES.ibRegistration);
        setServiceTypeForCallBack(SERVICE_TYPES.ibRegistration);
        break;
      case "ibservicechange":
        setServiceType(SERVICE_TYPES.IBservicechange);
        setServiceTypeForCallBack(SERVICE_TYPES.IBservicechange);
        break;
      case "kycform":
        setServiceType(SERVICE_TYPES.KYCform);
        setServiceTypeForCallBack(SERVICE_TYPES.KYCform);
        break;
      case "legal":
        setServiceType(SERVICE_TYPES.Legal);
        setServiceTypeForCallBack(SERVICE_TYPES.Legal);
        break;
      case "identification":
        setServiceType(SERVICE_TYPES.identification);
        setServiceTypeForCallBack(SERVICE_TYPES.identification);
        break;
      case "loan-application":
        setServiceType(SERVICE_TYPES.loanApplication);
        setServiceTypeForCallBack(SERVICE_TYPES.loanApplication);
        break;
      case "pi-onboarding":
        setServiceType(SERVICE_TYPES.piOnboarding);
        setServiceTypeForCallBack(SERVICE_TYPES.piOnboarding);
        break;
      case "callback":
        if (serviceTypeFromCallback.current)
          setServiceType(serviceTypeFromCallback.current);
        break;
      default:
        setServiceTypeForCallBack(SERVICE_TYPES.PIForm);
        return setServiceType(SERVICE_TYPES.PIForm);
    }
  }, [pathname]);

  return {
    serviceType,
    setServiceType,
    serviceTypeFromCallback,
    serviceTypeForCallBack,
  };
};

export default useServiceType;
